module.exports = __webpack_public_path__ + "/build/web/images/hero-warranty.4e50b12e233823fcff16c3cb3ef2aa0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-warranty.jpg
// module id = 154
// module chunks = 13